var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{
    [`btn-${_vm.color}`]: true,
    'w-full': _vm.full,
    'btn-loading': _vm.loading,
    [_vm.sizeClass]: true,
  },attrs:{"type":_vm.nativeType,"disabled":_vm.disabled},on:{"click":_vm.click}},[(_vm.icon)?_c('b-icon',{class:{ 'mr-1': _vm.iconSize === 'is-small', 'mr-2': _vm.iconSize !== 'is-small' },attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":_vm.iconSize}}):_vm._e(),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }